import { render, staticRenderFns } from "./setPassWord.vue?vue&type=template&id=5ae3c382&scoped=true&"
import script from "./setPassWord.vue?vue&type=script&lang=js&"
export * from "./setPassWord.vue?vue&type=script&lang=js&"
import style0 from "./setPassWord.vue?vue&type=style&index=0&id=5ae3c382&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3c382",
  null
  
)

export default component.exports